import { createWebHistory, createRouter } from 'vue-router';

import MainPage from './pages/MainPage.vue';
import DashboardPage from './pages/DashboardPage.vue';
import LoginPage from './pages/LoginPage.vue';
import TestPage from './pages/TestPage.vue';

import { isLoggedInUser, logout } from './composables/useAuth';

const routes = [
  {
    path: '/',
    redirect: '/grid/'
  },
  {
    path: '/dashboard/',
    component: DashboardPage
  },
  {
    path: '/grid/',
    component: MainPage
  },
  {
    path: '/login/',
    component: LoginPage
  },
  {
    path: '/test/',
    component: TestPage
  },
  {
    path: '/logout/',
    redirect: () => {
      logout();
      return '/login/';
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 };
  }
});

router.beforeEach(to => {
  if (to.path === '/test/') {
    return true;
  }
  if (to.path === '/login/' && isLoggedInUser.value) {
    return '/';
  }
  if (to.path !== '/login/' && !isLoggedInUser.value) {
    return '/login/';
  }
  return true;
});

export default router;
